<h1 mat-dialog-title>Cadastro de Processo</h1>

<div mat-dialog-content>
  <form [formGroup]="processForm" class="form-container">
    <!-- Seção Processo -->
    <section>
      <h3>Processo</h3>

      <div class="form-row">
        <!-- Tipo de Processo -->
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Tipo de Processo</mat-label>
          <input matInput formControlName="processType" readonly aria-label="Tipo de processo" />
        </mat-form-field>

        <!-- Prazo (em dias) -->
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Prazo (em dias)</mat-label>
          <input matInput type="number" formControlName="dueDays" [attr.aria-label]="'Prazo em dias'"
            [readonly]="true" /> </mat-form-field>
      </div>
    </section>

    <!-- Seção Informações -->
    <section>
      <h3>Informações</h3>

      <!-- Empresa ou Cidadão -->
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Empresa ou Cidadão</mat-label>
        <input type="text" matInput placeholder="Empresa ou Cidadão" formControlName="empresa"
          [matAutocomplete]="autoContributor" aria-label="Empresa ou cidadão" />
        <button mat-icon-button matSuffix aria-label="Pesquisar empresa ou cidadão">
          <mat-icon>search</mat-icon>
        </button>
        <mat-autocomplete #autoContributor="matAutocomplete">
          <mat-option *ngFor="let contributor of contributors" [value]="contributor.nome">
            {{ contributor.nome }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <!-- Cadastro do Imóvel -->
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Imóvel</mat-label>
        <input type="text" matInput placeholder="Informe o cadastro do imóvel" formControlName="propertyRegister"
          [matAutocomplete]="autoProperty" aria-label="Cadastro do imóvel" />
        <button mat-icon-button matSuffix aria-label="Pesquisar cadastro do imóvel">
          <mat-icon>search</mat-icon>
        </button>
        <mat-autocomplete #autoProperty="matAutocomplete">
          <mat-option *ngFor="let property of properties" [value]="property.id">
            {{ property.nome }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <!-- Descrição -->
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Descrição</mat-label>
        <textarea matInput formControlName="descricao" placeholder="Descreva o processo"
          aria-label="Descrição do processo"></textarea>
      </mat-form-field>

      <!-- Tema -->
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Tema</mat-label>
        <mat-select formControlName="theme" aria-label="Tema do processo">
          <mat-option *ngFor="let availableTheme of availableThemes" [value]="availableTheme.id">
            {{ availableTheme.nome }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Grupo -->
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Grupo</mat-label>
        <mat-select formControlName="group" aria-label="Grupo do processo">
          <mat-option *ngFor="let group of availableOpeningThemes" [value]="group.id">
            {{ group.nome }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Data de Cadastro -->
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Data de Cadastro</mat-label>
        <input matInput formControlName="registerDate" [attr.aria-label]="'Data de cadastro'" [readonly]="true" />
      </mat-form-field>
    </section>
  </form>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancelar</button>
  <button mat-button (click)="onSubmit()" [disabled]="processForm.invalid">Cadastrar</button>
</div>